<script setup>
import { Head } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <Head :title="t('title')" />

  <AuthCard>
    <template #title>{{ t('title') }}</template>
  </AuthCard>
</template>

<i18n>
{
    "en": {
        "title": "Confirm Password",
        "form": {
            "password": {
                "label": "Password",
                "placeholder": "Enter your password"
            },
            "confirm_password": {
                "label": "Confirm Password",
                "placeholder": "Re-enter your password"
            },
            "submit": {
                "label": "Confirm Password"
            }
        }
    },
    "de": {
        "title": "Passwort bestätigen",
        "form": {
            "password": {
                "label": "Passwort",
                "placeholder": "Gib dein Passwort ein"
            },
            "confirm_password": {
                "label": "Passwort bestätigen",
                "placeholder": "Gib dein Passwort erneut ein"
            },
            "submit": {
                "label": "Passwort bestätigen"
            }
        }
    }
}
</i18n>
